import React from 'react';
import projekt_logo_big from './../images/projekt_logo_veliki.svg';
import esf_logo from './../images/esf_logo.svg';
import esif_logo from './../images/esif_logo.svg';
import EU_logo from './../images/EU_logo.svg';
import projekt_logo from './../images/projekt_logo_mali.svg';

export default class BackLink extends React.Component {

  render() {

    const logos = <div>
        <img height={40} alt ="projekt_logo" src={projekt_logo} />
        <img height={40} alt ="EU_logo" src={EU_logo} />
        <img height={40} alt ="esf_logo" src={esf_logo} />
        <img height={40} alt ="esif_logo" src={esif_logo} />
          <p style={{clear: 'both'}}>
            Projekt je sufinancirala Europska unija iz Europskog socijalnog fonda
            <br />
            Sadržaj ove internetske stranice isključiva je odgovornost Centra za razvoj radničke participacije.
          </p>

      </div>

    let lead_text = ""
    switch (this.props.site) {
      case 'ns':
        lead_text = "Sindikat Nova Solidarnost parner je na projektu"
        break;
      case 'ris':
        lead_text = "Regionalni industrijski sindikat nositelj je projekta"
        break;
      case 'crrp':
        lead_text = "Centar za razvoj radničke participacije partner je na projektu"
        break;
    }

    return <div className="project_text">
            <img height={300} alt ="projekt_logo" src={projekt_logo_big} />
            <p>{lead_text} Unapređenje socijalnog dijaloga kroz razvoj stručnih i kadrovskih kapaciteta regionalnih sindikata i organizacija civilnog društva, u čijoj provedbi sudjelujemo s ciljem stjecanja dodatnih znanja i iskustava te s misijom učvršćivanja naše suradnje s relevantnim sindikatima, sindikalnim profesionalcima i aktivistima.</p>
            <br />
            <div className="project_text_disclamer">
              <a className="project_more" href={"#informacije-o-projektu"} onClick={() => this.props.getData("informacije-o-projektu")}>Više o projektu</a>
            </div>
          </div>
  }
}
